import * as React from 'react'
function SvgImage(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 4c1.2 0 2 .8 2 2v28c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2V6c0-1.2.8-2 2-2h28zm-2 4H8v24h24V8zm-8 8l6 12H10l4-8 4 4 6-8zm-8-4c1.2 0 2 .8 2 2s-.8 2-2 2-2-.8-2-2 .8-2 2-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgImage
